import { render, staticRenderFns } from "./AmountDoctorChart.vue?vue&type=template&id=67b07129&scoped=true&"
import script from "./AmountDoctorChart.vue?vue&type=script&lang=js&"
export * from "./AmountDoctorChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b07129",
  null
  
)

export default component.exports